var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIosIpadIphonFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 50,
    viewBox: "0 0 65 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.7426,
    y: 29.4387,
    width: 10.8956,
    height: 18.5226,
    rx: 2.17912,
    stroke: "#EFB729",
    strokeWidth: 2.17912
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1904 25.08V4.3783C58.1904 2.57306 56.7269 1.10962 54.9217 1.10962H4.80183C2.99659 1.10962 1.53314 2.57306 1.53314 4.37831V35.9756C1.53314 37.7809 2.99658 39.2443 4.80183 39.2443H26.5931",
    stroke: "#EFB729",
    strokeWidth: 2.17912,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5931 33.7963C27.1948 33.7963 27.6826 33.3085 27.6826 32.7068C27.6826 32.105 27.1948 31.6172 26.5931 31.6172V33.7963ZM1.53314 33.7963H26.5931V31.6172H1.53314V33.7963Z",
    fill: "#EFB729"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9513 22.9008C30.9513 21.6973 31.9269 20.7216 33.1304 20.7216H46.2052C47.4087 20.7216 48.3843 21.6973 48.3843 22.9008V45.7816C48.3843 46.9851 47.4087 47.9607 46.2052 47.9607H33.1304C31.9269 47.9607 30.9513 46.9851 30.9513 45.7816V22.9008Z",
    stroke: "#EFB729",
    strokeWidth: 2.17912
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3244 39.2444L21.1453 47.9609",
    stroke: "#EFB729",
    strokeWidth: 2.17912,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.414 47.9609H18.9662",
    stroke: "#EFB729",
    strokeWidth: 2.17912,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIpadIphonFrame);
export default __webpack_public_path__ + "static/media/ios-ipad-iphon-frame.6f203b036feafc3b493c30cb9bc6a815.svg";
export { ForwardRef as ReactComponent };